/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionskindstatus3Inputs */

const en_openquestionskindstatus3 = /** @type {(inputs: Openquestionskindstatus3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const pt_openquestionskindstatus3 = /** @type {(inputs: Openquestionskindstatus3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Openquestionskindstatus3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionskindstatus3 = /** @type {((inputs?: Openquestionskindstatus3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionskindstatus3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionskindstatus3(inputs)
	return pt_openquestionskindstatus3(inputs)
});
export { openquestionskindstatus3 as "openQuestionsKindStatus" }